/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/dom.css';
import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--img in content--*/
import Main from '../assets/img/domPomoc.webp';

import sprzet1 from '../assets/produkty/sankiLadowe.webp';
import sprzet2 from '../assets/produkty/lodzRatunkowa.webp';
import sprzet3 from '../assets/produkty/platformaRat.webp';
import sprzet4 from '../assets/produkty/drabina.webp';
import sprzet5 from '../assets/produkty/workiPrzeciw.webp';
import sprzet6 from '../assets/produkty/latarka.jpg';
import sprzet7 from '../assets/produkty/dekantominacja.webp';
import sprzet8 from '../assets/produkty/pianotworcze.webp';
import sprzet9 from '../assets/produkty/szybkoRozkład.webp';


/*========================================
        Middle!!!
=========================================*/

function Middle() {
    return (
        <>
        <section className='Middle'>
            {/*--stick publicity--*/}
            <section className='publicity'>
                <Row className='entry'>
                    {/*--text--*/}
                    <Col lg={5} md={12} sm={12} className='p-1 describe'>
                        <h1>Ratownictwo i ewakuacja</h1>
                        <h5>
                            Sprzęt do ratownictwa i ewakuacji pomaga bezpiecznie wyprowadzić ludzi z zagrożonego terenu. Jego obecność może uratować życie w sytuacjach nagłych, takich jak pożar czy zalanie.
                        </h5>
                    </Col>
                    {/*--img--*/}
                    <Col lg={6} md={12} sm={12} className='lg-p-3 xs-p-1'>
                        <div className="image-container">
                            <img src={Main} alt='ilustration of the main theme'/>    
                        </div>
                    </Col >
                </Row>
                {/*--choose the stick--*/}
                <section className='ChooseYour'>
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet1} alt="sprzęt ilustracja"/>
                            <span>Sanki lądowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet2} alt="sprzęt ilustracja"/>
                            <span>Łodzie</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet3} alt="sprzęt ilustracja"/>
                            <span>Platformy ratownicze</span>
                        </Col>
                    </Row> 
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet4} alt="sprzęt ilustracja"/>
                            <span>Drabiny</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet5} alt="sprzęt ilustracja"/>
                            <span>Worki przeciwpowodziowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet6} alt="sprzęt ilustracja"/>
                            <span>Latarka</span>
                        </Col>
                    </Row> 
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet7} alt="sprzęt ilustracja"/>
                            <span>Zestaw do dekantominacji</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet8} alt="sprzęt ilustracja"/>
                            <span>Środki pianotwórcze</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet9} alt="sprzęt ilustracja"/>
                            <span>zbiornik szybko rozkładalny</span>
                        </Col>
                    </Row>    
                </section>
            </section>
          </section>
        </>
    );
}

function Equipment() {
    return (
        <>
          <Header />
          <Middle/>
          <Footer/> 
        </>
    );
}

export default Equipment;